export default __webpack_public_path__ + "static/media/wireless-bluetooth-1.23cd1751.png";